<span
  class="incident-tag"
  [matTooltip]="incidentTooltip"
  matTooltipClass="incident-tag-tooltip"
>
  {{ "incident.title" | translate }}
</span>
